import CompaniesPage from './companies-page';

export default CompaniesPage;